import { render, staticRenderFns } from "./CreateSplit.vue?vue&type=template&id=6f275285&"
import script from "./CreateSplit.vue?vue&type=script&lang=js&"
export * from "./CreateSplit.vue?vue&type=script&lang=js&"
import style0 from "./CreateSplit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports